<template>
  <div id="disclaimer-container" :class="type">
    <i :class="iconClass" aria-hidden="true"></i>
    <div class="disclaimer-content">
      <slot></slot>
    </div>
  </div>
</template>

<style>
#disclaimer-container .disclaimer-content p {
  color: var(--kate-type-white);
}

[data-theme="light"] #disclaimer-container .disclaimer-content p {
  color: var(--kate-type-primary) !important;
}
</style>

<style scoped>
#disclaimer-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  box-shadow: var(--box-shadow);
  background-color: rgb(18 18 18 / 0.7);
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 4px;
  border-left: 6px solid var(--kate-type-blue);
}

#disclaimer-container.warning {
  border-left: 6px solid var(--kate-warning);
}

#disclaimer-container.error {
  border-left: 6px solid var(--kate-danger);
}

#disclaimer-container.success {
  border-left: 6px solid var(--kate-success);
}

#disclaimer-container > i {
  font-size: 2.5em;
  color: var(--kate-type-blue);
}

#disclaimer-container.warning > i {
  color: var(--kate-warning);
}

#disclaimer-container.error > i {
  color: var(--kate-danger);
}

#disclaimer-container.success > i {
  color: var(--kate-success);
}
/* Light theme overrides */
[data-theme="light"] #disclaimer-container {
  background-color: var(--kate-background-alt-alpha);
  box-shadow: var(--box-shadow-alt);
}

[data-theme="light"] #disclaimer-container.error {
  border-left: 6px solid var(--kate-type-danger);
}

[data-theme="light"] #disclaimer-container.error > i {
  color: var(--kate-type-danger);
}
</style>

<script>
const ICON_MAP = {
  info: 'fas fa-info-circle',
  warning: 'fas fa-exclamation-triangle',
  error: 'fas fa-exclamation-circle',
  success: 'fas fa-check-circle',
};

export default {
  props: {
    // type can be 'info', 'warning', 'error', or 'success'
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'warning', 'error', 'success'].includes(value),
    },
  },
  computed: {
    iconClass() {
      return ICON_MAP[this.type];
    },
  },
};
</script>
